import {SiteType} from '@wp-content-publisher/typings-lib';
import {apiRequest} from '../../../shared/utils/api-request.helper.ts';

export const searchSite = async (search: string): Promise<SiteType[]> =>
    await apiRequest({
        url: '/sites',
        queryParams: {search}
    });